import * as R from 'ramda'
import { Product } from '../actions'

const reducer = (state = {}, action) =>
  R.cond([
    [R.equals(Product.TYPE.receive), R.always(action.payload)],
    [R.T, R.always(state)],
  ])(action.type)

export default reducer
